
export const InputErrorMessages = {
  required: 'Required. Please add Field.',
};

export const TextAreaErrorMessages = {
  required: 'Required. Please add Field.',
};